import type { FC } from 'react';

import { ButtonAction } from 'components/button/ButtonAction';
import { Button, Modal, Typography, closeModal } from 'enable-ui';

import { MODAL_KEY } from 'modules/auth/core/modal-key';

import { ModalWrapperAbsent } from '../styles/lesson';

import { ReactComponent as AvatarIcon } from 'assets/icons/avatar.svg';

import type { LearnerMarkingAbsence } from '../core/type';

export const ClassAbsentModal: FC<{
  learnerMarkingAbsence: LearnerMarkingAbsence[];
  handleAbsent: (userId: string) => void;
  handleSubmitAbsentLearner: () => void;
  handleCancel: () => void;
}> = ({ learnerMarkingAbsence, handleAbsent, handleSubmitAbsentLearner, handleCancel }) => {
  const haveAbsentLength = learnerMarkingAbsence.filter((ele) => ele.isAbsent).length;

  return (
    <ModalWrapperAbsent>
      <Modal
        modalKey={MODAL_KEY.CLASS_ABSENT}
        closeOnClickOutside={false}
        hideCloseIcon
        header={
          <Typography variant="h4" style={{ fontSize: 22, fontWeight: '500' }}>
            Marking absence
          </Typography>
        }
        onSubmit={() => handleSubmitAbsentLearner()}
        size="lg"
        footer={
          <ButtonAction
            disabledCancel={false}
            disabledSubmit={false}
            titleCancel="Cancel"
            titleSubmit={`Mark ${haveAbsentLength} as absent`}
            style={{ justifyContent: 'end', padding: '0px 40px 24px 0px' }}
            onSubmit={() => handleSubmitAbsentLearner()}
            onCancel={handleCancel}
          />
        }
      >
        {learnerMarkingAbsence.map((learner) => (
          <div
            key={learner.userId}
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '12px 0px' }}>
              {learner.avatar ? (
                <img
                  src={learner.avatar}
                  alt="avatar"
                  style={{
                    width: 36,
                    height: 36,
                    borderRadius: '50%',
                    objectFit: 'cover',
                  }}
                />
              ) : (
                <AvatarIcon style={{ width: 36, height: 36 }} />
              )}
              <Typography
                style={{
                  fontSize: 16,
                  fontWeight: 500,
                  lineHeight: '22px',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  maxWidth: '410px',
                }}
              >
                {learner.name}
              </Typography>
            </div>

            <Button
              size="small"
              style={{
                borderRadius: 16,
                color: learner.isAbsent ? '#FF4D4F' : '',
                backgroundColor: learner.isAbsent ? '#FFF1F0' : '',
                borderColor: learner.isAbsent ? '#FFA39E' : '',
              }}
              onClick={() => handleAbsent(learner.userId)}
            >
              Absent
            </Button>
          </div>
        ))}
      </Modal>
    </ModalWrapperAbsent>
  );
};
